import type { ClaimQuestResponse, DailyStatusResponse } from '@cradle7/shared';
import { useSyncExternalStore } from 'react';

let status: DailyStatusResponse | null = null;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((fn) => fn());
}

export function getDailyStatus(): DailyStatusResponse | null {
  return status;
}

export function setDailyStatus(s: DailyStatusResponse): void {
  status = s;
  emit();
}

export function applyClaimResult(r: ClaimQuestResponse): void {
  if (!status) return;
  status = {
    ...status,
    fishies: r.totalFishies,
    quests: status.quests.map((q) =>
      q.id === r.questId ? { ...q, claimed: true } : q
    ),
  };
  emit();
}

export function subscribeDailyStatus(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

/** Test hook: clear in-memory state + listeners. */
export function _clearDailyStatus(): void {
  status = null;
  listeners.clear();
}

let snapshotKey: DailyStatusResponse | null = null;
let snapshotCache: DailyStatusResponse | null = null;

function getSnapshot(): DailyStatusResponse | null {
  if (snapshotKey === status) return snapshotCache;
  snapshotKey = status;
  snapshotCache = status;
  return status;
}

export function useDailyStatus(): DailyStatusResponse | null {
  return useSyncExternalStore(subscribeDailyStatus, getSnapshot, getSnapshot);
}
